module.exports = __webpack_public_path__ + "img/dwg.011d0bd0.svg";